import { Hero, formatCurrencyByLocale } from 'member-web-shared-components';
import { UniversityHeroProps } from '../../types/App';
import './UniversityHero.scss';

const UniversityHero = (props: UniversityHeroProps) => {
  const {
    componentId,
    title,
    description,
    backgroundColor,
    image,
    orgName,
    savings,
    language,
    currency
  } = props;

  const normalizeCurrency = (value: string) => value.replace(/(\.|,)00$/g, '');

  const setTokens = (
    markup: string,
    orgName: string,
    savings: string,
    language: string,
    currency: string
  ) => {
    const orgNameTokenRegex = /{{orgName}}/g;
    const savingsTokenRegex = /{{savings}}/g;

    let returnMarkup = markup;

    if (orgNameTokenRegex.test(markup)) {
      returnMarkup = returnMarkup.replace(
        orgNameTokenRegex,
        orgName
      );
    }
    const savingsWithCurrency = normalizeCurrency(formatCurrencyByLocale({ value: Number(savings), currency }));
    if (savingsTokenRegex.test(markup)) {
      returnMarkup = returnMarkup.replace(
        savingsTokenRegex,
        savingsWithCurrency
      );
    }
    return returnMarkup;
  };

  const formattedTitle = setTokens(title, orgName, savings, language, currency);

  return (
    <div
      data-testid={componentId}
      className='university-hero'
    >
      <Hero
        title={formattedTitle}
        description={description}
        backgroundColor={backgroundColor}
        image={image}
        extraClass='mwsc-hero__presales'
      />
    </div>
  );
};

export default UniversityHero;
